import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Hidden from '@material-ui/core/Hidden'
import MenuIcon from '@material-ui/icons/Menu'
import Logo from './LogoHeig'
import { Link } from '@reach/router'

const useStyles = makeStyles((theme) => ({
    menuButton: {
        position: 'absolute',
        left: 8,
        top: '50%',
        transform: 'translateY(-50%)',
        borderRadius: 8,
        padding: '6px 12px',
    },
    title: {
        color: '#777',
        textDecoration: 'none',
        textAlign: 'center',
    },
    logo: {
        position: 'absolute',
        width: 40,
        left: 24,
        top: 10,
        // eslint-disable-next-line
        ['@media (min-width:600px)']: {
            width: 48,
            top: 16,
        },
    },
    appBar: {
        background: 'white',
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
    },
}))

export default ({ onMenuClick }) => {
    const styles = useStyles()
    return (
        <AppBar position="static" className={styles.appBar}>
            <Toolbar className={styles.toolbar}>
                <Hidden mdUp>
                    <IconButton
                        edge="start"
                        className={styles.menuButton}
                        onClick={onMenuClick}
                        aria-label="menu"
                    >
                        <MenuIcon />
                    </IconButton>
                </Hidden>
                <Hidden smDown>
                    <Logo className={styles.logo} />
                </Hidden>
                <Link to="/" className={styles.title}>
                    <Typography variant="h6" className={styles.title}>
                        Admissions HEIG-VD
                    </Typography>
                </Link>
            </Toolbar>
        </AppBar>
    )
}
